import { render, staticRenderFns } from "./MaxLineItems.vue?vue&type=template&id=83ced462"
import script from "./MaxLineItems.vue?vue&type=script&lang=ts"
export * from "./MaxLineItems.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports